export const STATIC_CLASSES = Object.freeze({
	root: 'banner3',
	imageGrid: 'banner3-image-container',
	desktopImage: 'banner3-image',
	wrapContainer: 'banner3-container',
	textWrap: 'banner3-container',
	title: 'banner3-text-block-title',
	subtitle: 'banner3-subtitle-wrapper',
	subtitleText: 'banner3-text-block-subtitle',
	mobileImage: 'banner3-image-mobile',
	text: 'banner3-text-block',
	buttonContainer: 'banner3-button-wrapper',
	action: 'banner3-button-actions',
	bgImage: 'banner3-bg-image',
})
